<template>
  <div style="height: 100%">
    <div class="header flex flex-between">
      <div class="lef">
        <router-link :to="{path:'/index/home'}" tag="div" class="header-logo flex">
          <!-- <img src="../assets/images/logo_blue.png" alt="logo" style="margin-right: 2px;"> -->
          <img src="../assets/images/zaitaxiang.svg" alt="logo" style="margin-right: 2px;">
        </router-link>
        <div @click="toChat" class="chat">
          <img class="img" src="../assets/images/logo-chat.png" alt="" />
          Ai工作助手
        </div>
      </div>
      <div class="rig flex">
        <!-- <div class="tab-item flex m-r-36">
          <img class="t-icon" src="../assets/images/icon_order.png" alt="logo" />
          我的订单
        </div> -->
        <div class="tab-item flex m-r-36" @click="toNotice">
          <!-- <div class="msg-thound" v-if="noticeNum > 0">{{ noticeNum }}</div> -->
          <img class="t-icon" src="../assets/images/icon_msg.png" alt="logo" />
          消息
        </div>
        <span class="short-line m-r-36" v-if="hrinfo" />
        <div class="tab-item flex m-r-36" style="cursor: default;" v-if="hrinfo">
          <img class="t-face" v-if="!hrinfo.headImage" src="../assets/images/face.png" alt="" />
          <img class="t-face" :src="hrinfo.headImage" v-else alt="" />
          <span class="span">{{`${hrinfo.name}/${hrinfo.companyShortname}`}}</span>
        </div>
        <el-dropdown @command="onCommand" v-if="hrinfo">
          <div class="flex" style="cursor: pointer;">
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click="goPerson" command="goPerson">个人信息</el-dropdown-item>
            <el-dropdown-item @click="logout" command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-dropdown class="right-btns" @command="onCommand">
          <div class="flex" style="cursor: pointer;">
            <img v-if="!hrinfo.headImage" src="../assets/images/face.png" class="h-u-faceimg" alt="" />
            <img class="h-u-faceimg" :src="hrinfo.headImage" v-else alt="" />
            <p class="h-u-name">{{hrinfo.name}}</p>
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click="goPerson" command="goPerson">个人信息</el-dropdown-item>
            <el-dropdown-item @click="pwdModify" command="pwdModify">修改密码</el-dropdown-item>
            <el-dropdown-item @click="logout" command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
    <div class="content flex align-start" v-if="hrinfo">
      <div class="menu" v-if="targetShow">
        <div class="menu-height">
          <!-- <el-dropdown @command="handleCommand" trigger="click" style="margin-bottom: 24px; cursor: pointer">
            <div class="m-compname">
              <div class="comp-img">
                <img src="../assets/images/face.png" v-if="!hrinfo.companyLogo" alt="" />
                <img :src="hrinfo.companyLogo" v-else alt="" />
              </div>
              <div class="change-btn " v-if="companylist.length>1">切换</div>
            </div>
            <el-dropdown-menu class="comp-drop-container" slot="dropdown" v-if="companylist.length>1">
              <el-dropdown-item style="width:200px;" :key="item.companyId" v-for="item in companylist" :command="item">
                {{item.shortName}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <router-link class="nav-item" active-class="active" :to="{path:'/index/home'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/user_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/user.png" alt="" />
            我的桌面
          </router-link>
          <router-link class="nav-item" active-class="active" :to="{path:'/index/resume/list'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/solution_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/solution.png" alt="" />
            简历管理
          </router-link>
          <router-link class="nav-item" active-class="active" :to="{path:'/index/posts'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/wrench_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/wrench.png" alt="" />
            岗位管理
          </router-link>
          <router-link class="nav-item" active-class="active" :to="{path:'/index/jobfair'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/id_card_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/id_card.png" alt="" />
            招聘会
          </router-link>
          <router-link class="nav-item" active-class="active" :to="{path:'/index/album'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/image_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/image.png" alt="" />
            企业相册
          </router-link>
          <router-link class="nav-item" v-if="hrinfo.role === 1" active-class="active" :to="{path:'/index/staff'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/cluster_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/cluster.png" alt="" />
            组织架构
          </router-link>
          <router-link class="nav-item" active-class="active" :to="{path:'/index/finance'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/money_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/money.png" alt="" />
            财务管理
          </router-link>
          <router-link class="nav-item" active-class="active" :to="{path:'/index/member/info'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/crown_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/crown.png" alt="" />
            会员特权
          </router-link>
          <router-link class="nav-item" active-class="active" :to="{path:'/index/company'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/setting_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/setting.png" alt="" />
            企业设置
          </router-link>
          <!--<router-link class="nav-item" active-class="active" :to="{path:'/index/product'}" tag="dd">
            <img class="ac" src="../assets/images/right-nav/product_a.png" alt="" />
            <img class="df" src="../assets/images/right-nav/product.png" alt="" />
            企业超市
          </router-link>-->
        </div>
      </div>
      <div class="content-right" :class="{'content-ling-right':!targetShow}">
        <transition name="fade" mode="out-in">
          <router-view @pwd-modify="pwdModify" />
        </transition>
      </div>
    </div>
    <Modal :show="modalshow" modal-title="修改登录密码" @cancelHander="cancel" @conformHander="conform">
      <div slot="modal-content">
        <div class="ztx-mess-item">
          <div class="clearfix">
            <div class="ztx-mess-name">旧密码</div>
            <input type="password" autocomplete="off" v-model="oldPass" class="ztx-mess-inp" placeholder="请输入旧密码">
          </div>
          <p class="ztx-mess-tx"></p>
        </div>
        <div class="ztx-mess-item clearfix">
          <div class="clearfix">
            <div class="ztx-mess-name">新密码</div>
            <input type="password" v-model="password" class="ztx-mess-inp" placeholder="请输入新密码">
          </div>
          <p class="ztx-mess-tx"></p>
        </div>
        <div class="ztx-mess-item clearfix">
          <div class="clearfix">
            <div class="ztx-mess-name">重复输入</div>
            <input type="password" v-model="repetPass" class="ztx-mess-inp" placeholder="请再次输入新密码">
          </div>
          <p class="ztx-mess-tx"></p>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Modal from '../components/Modal.vue';
  import { mapState, mapMutations } from 'vuex';
  import NoticeCarousel from '../components/NoticeCarousel.vue';

  export default {
    data() {
      return {
        searchContent: '',
        isHrinfoShow: false,
        modalshow: false,
        oldPass: '',
        password: '',
        repetPass: '',
        companylist: [],
        isshowserch: false,
        activeTxt: 'home',
        noticeNum: 0
      };
    },
    beforeRouteEnter(to, from, next) {
      if (to.meta.showsearch) {
        next(vm => {
          vm.isshowserch = true;
        });
      } else {
        next();
      }
    },
    beforeRouteUpdate(to, from, next) {
      this.isshowserch = to.meta.showsearch;
      next();
    },
    created() {
      this.getInfo();
      this.getCompanyList();
      this.getNoticeNums()
    },
    components: {
      Modal: Modal,
      NoticeCarousel
    },
    computed: {
      ...mapState({
        hrinfo: 'hrinfo',
        targetShow: 'targetShow'
      })
    },
    methods: {
      ...mapMutations(['hrinfoMo']),
      getNoticeNums() {
        this.axios.get(`/wapi/notice/list?pageNum=1&pageSize=10`).then(res => {
          this.noticeNum = res.total || 0
        });
      },
      onCommand(command) {
        this[command]();
      },
      getInfo() {
        this.axios.get('/wapi/hr/get').then(res => {
          this.hrinfoMo(res.data);
        });
      },
      pwdModify() {
        this.modalshow = true;
        this.oldPass = '';
        this.password = '';
        this.repetPass = '';
      },
      cancel() {
        this.modalshow = false;
      },
      conform() {
        if (this.oldPass.length === 0) {
          this.$message.warning('请输入旧密码');
          return;
        }
        if (this.password.length === 0) {
          this.$message.warning('请输入新密码');
          return;
        }
        if (this.repetPass.length === 0) {
          this.$message.warning('请输入重复密码');
          return;
        }
        if (this.repetPass !== this.password) {
          this.$message.warning('两次密码输入不一致');
          return;
        }
        let url = `/wapi/hr/modifyPwd?oldPass=${this.oldPass}&password=${this.password}&repetPass=${this.repetPass}`;
        this.axios.get(url).then(res => {
          this.modalshow = false;
          if (res.success) {
            this.$message.success('密码修改成功');
          }
        });
      },
      parentSearch() {
        this.$store.commit('searchChange', this.searchContent);
        this.$router.push({ path: '/index/searchList' });
      },
      goPerson() {
        this.$router.push({ path: '/index/home/person' });
      },
      logout() {
        this.axios.get('/wapi/hr/logout').then(res => {
          if (res.success) {
            this.$router.push('/login');
            window.location.reload();
          }
        });
      },
      getCompanyList() {
        let url = '/wapi/hr/listCompany';
        this.axios.get(url).then(res => {
          if (res.success) {
            this.companylist = res.data;
          }
        });
      },
      handleCommand(item) {
        let url = `/wapi/hr/swichCompany?companyId=${item.companyId}&companyName=${this.name}&companyShortName=${this.shortName}`;
        this.axios.get(url).then(res => {
          if (res.success) {
            window.location.reload();
          }
        });
      },
      toNotice() {
        this.$router.push('/index/home/notice')
      },
      toChat() {
        window.open('/chat', '_blank');
      }
    }
  };
</script>

<style lang="less" scoped>
  @import url('../assets/less/base.less');
  @import "../assets/css/public";

  @head-height: 70px;
  .header {
    height: 76px;
    max-width: 1470px;
    margin: 0 auto;

    .lef {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .chat {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 132px;
        height: 34px;
        padding: 7px 14px;
        margin-left: 15px;
        background: #FFFFFF;
        border-radius: 6px;
        font-size: 16px;
        color: #141414;
        line-height: 20px;
        cursor: pointer;

        .img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
        }
      }
    }

    .header-logo {
      width: 156px;
      padding: 0 12px;
      font-size: 16px;
      cursor: pointer;

      img {
        width: 132px;
        height: 34px;
      }
    }

    .tab-item {
      position: relative;
      cursor: pointer;
      font-size: 14px;

      .t-icon {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }

      .t-face {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        border-radius: 50%;
      }

      .span {
        font-size: 14px;
        color: #141414;
        line-height: 20px;
      }
    }

    .m-r-36 {
      margin-left: 36px;
    }

    .short-line {
      width: 1px;
      height: 12px;
      background-color: rgba(20, 20, 20, 0.20);
    }

    .msg-thound {
      position: absolute;
      right: -18px;
      top: -5px;
      width: 18px;
      height: 12px;
      text-align: center;
      line-height: 12px;
      background: #FF4D4F;
      border-radius: 6px;
      color: #ffffff;
      font-size: 10px;
    }

    .el-icon-arrow-down {
      margin-left: 8px;
      font-size: 12px;
    }

    .notice-box {
      height: 44px;
      background: #F8F8F8;
      border-radius: 2px;
      padding-left: 28px;
      padding-right: 25px;

      .notice-name {
        font-size: 18px;
        color: #E02020;

        &::after {
          content: '';
          display: block;
          width: 1px;
          height: 25px;
          background: #BDBDBD;
          margin: 0 30px;
        }
      }

      .go-more {
        font-size: 14px;
        color: #888888;
        margin-left: 36px;
      }
    }

    .right-btns {
      width: 154px;
      display: flex;
      justify-content: flex-end;

      .h-u-faceimg {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }

      .el-icon--right {
        margin-left: 14px;
      }
    }
  }

  .content {
    // padding:  @head-height + 24px 40px 24px 24px;
    height: e("calc(100% - 91px)");

    .menu {
      max-height: 100%;
      width: 156px;
      background: #fff;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      padding: 14px 0;
      margin-left: 0;
      @media screen and (min-width: 1470px) {
        margin-left: calc(~'50% - 735px');
      }

      .menu-height {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-height: calc(~'100% - 28px');
        overflow-y: auto;
      }

      .comp-img {
        width: 70px;
        height: 70px;
        margin-bottom: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .change-btn {
        width: 44px;
        height: 19px;
        line-height: 19px;
        background: @color-primary;
        border-radius: 10px;
        font-size: 12px;
        color: #fff;
        text-align: center;
        margin: 0 auto 0;
      }

      .comp-drop-container {
        max-height: 280px;
        overflow: auto;
      }

      .nav-item {
        padding-left: 23px;
        width: 128px;
        height: 44px;
        line-height: 44px;
        box-sizing: border-box;
        cursor: pointer;
        border-radius: 4px;
        font-size: 14px;
        color: rgba(38, 42, 50, 1);

        img {
          width: 16px;
          height: 16px;
          margin-right: 2px;

          &.ac {
            display: none;
          }
        }

        &.active {
          background: linear-gradient(90deg, #057CF9 0%, #1AAFFD 100%);
          color: #fff;

          img.ac {
            display: inline-block;
          }

          img.df {
            display: none;
          }
        }
      }
    }

    .content-right {
      flex: 1;
      height: 100%;
      margin-left: 15px;
      border-radius: 10px;
      overflow-y: auto;
      font-size: 16px;
      padding-right: calc(~'50% - 735px');

      &.content-ling-right {
        max-width: calc(~'1470px + calc(100% - 1470px)');
        margin: 0;
        padding-left: calc(~'50% - 735px');
        padding-right: calc(~'50% - 735px');
      }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?adaf2566